import { mergeObjectTypes } from '../cacheHelpers';

const PurchaseOrderEstimatedDateType = {
  merge: mergeObjectTypes
};

export default PurchaseOrderEstimatedDateType;
